import { render } from "./newEvent.vue?vue&type=template&id=60fd0d08&scoped=true"
import script from "./newEvent.vue?vue&type=script&lang=js"
export * from "./newEvent.vue?vue&type=script&lang=js"

import "./newEvent.vue?vue&type=style&index=0&id=60fd0d08&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fd0d08"]])

export default __exports__